import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { PdfCard, PdfType } from "../../../pages/new-platform/components/PdfCard";
import { Exam } from "../../../utils/api-objects/Exam";
import { getHealthPlanPdf } from "../../../utils/apis/plan-service";
import { useAuthStore } from "../../../utils/stores/useAuthStore";
import LoadingSpinner from "../../shared/components/Loaders";

const HealthPlanPdfsPage = () => {
    const { auth } = useAuthStore()
    const idToken = auth.idToken
    const userId = auth.userId
    const location = useLocation()
    const searchParams = new URLSearchParams(location.search);
    const healthPlanId = searchParams.get("health_plan_id");
    const type = searchParams.get("type");

    const navigate = useNavigate()

    const [isGeneralLoading, setIsGeneralLoading] = useState(true);

    const [pdfs, setPdfs] = useState<Exam[]>()

    const getHealthPlanUrls = async () => {
        if (!userId || !idToken) return
        const folder = `${healthPlanId}/${type}`
        try {
            const urls = await getHealthPlanPdf(userId, idToken, folder)
            setPdfs(urls)
        } catch (error) {
            console.log(error)
        } finally {
            setIsGeneralLoading(false)
        }
    }

    useEffect(() => {
        getHealthPlanUrls()
    }, [])

    if (isGeneralLoading || !pdfs) {
        return (
            <LoadingSpinner />
        );
    }

    return (
        <div className="w-full h-full flex flex-col pt-[20px]">
            <div className="w-full space-y-[20px] pb-[20px]">
                {/* <BackButton
                    text={`Torna a Health Plan`}
                    onClick={() => navigate(`/health-plan`)}
                />
                <div className="font-bold text-[35px] leading-[35px]">
                    {
                        type === HealthPlanPdfType.Materials ? "🗂️ Materiali di approfondimento" : "📄 Prescrizioni"
                    }
                </div> */}
                <div className="w-full pb-[20px]">
                    <div className="flex flex-col md:flex-row md:flex-wrap gap-4">
                        {pdfs.map((pdf, index) => (
                            <PdfCard key={index} exam={pdf} pdfType={PdfType.Uploads} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HealthPlanPdfsPage
